<section tuiContent class="text-left gap-10 flex flex-col">
	<ng-container
		*ngTemplateOutlet="
			item;
			context: {
				label: 'analyses.dialog.analysis-details.name' | transloco,
				value: analysis()?.name,
			}
		"
	/>

	@for (period of analysis()?.timePeriods; track period) {
		<div class="flex gap-3">
			<ng-container
				*ngTemplateOutlet="
					item;
					context: {
						label:
							'analyses.dialog.analysis-details.time-period.min-date'
							| transloco: { count: $index + 1 },
						value: period.minDate | timestamp: 'UTC',
					}
				"
			/>

			<ng-container
				*ngTemplateOutlet="
					item;
					context: {
						label:
							'analyses.dialog.analysis-details.time-period.max-date'
							| transloco: { count: $index + 1 },
						value: period.maxDate | timestamp: 'UTC',
					}
				"
			/>

			<ng-container
				*ngTemplateOutlet="
					item;
					context: {
						label:
							'analyses.dialog.analysis-details.time-period.overhead-costs'
							| transloco: { count: $index + 1 },
						value:
							period.overheadCostInCents
							| centsToDollars
								: { currency: analysis()?.currency },
					}
				"
			/>
		</div>
	}

	<ng-container
		*ngTemplateOutlet="
			item;
			context: {
				label:
					'analyses.dialog.analysis-details.cost-type.label'
					| transloco,
				value:
					'analyses.dialog.analysis-details.cost-type.' +
						analysis()?.costType | transloco,
			}
		"
	/>

	<ng-container
		*ngTemplateOutlet="
			item;
			context: {
				label: 'currency.label' | transloco,
				value: analysis()?.currency
					? ('currency.' + analysis()!.currency | transloco)
					: null,
			}
		"
	/>

	<div class="mar-divider"></div>

	<div class="flex gap-3">
		<ng-container
			*ngTemplateOutlet="
				item;
				context: {
					label:
						'analyses.dialog.analysis-details.created' | transloco,
					value: analysis()
						? (analysis()!.createdAt | timestamp)
						: null,
				}
			"
		/>

		<ng-container
			*ngTemplateOutlet="
				item;
				context: {
					label:
						'analyses.dialog.analysis-details.last-modified'
						| transloco,
					value: analysis()
						? (analysis()!.updatedAt | timestamp)
						: null,
				}
			"
		/>

		<ng-container
			*ngTemplateOutlet="
				item;
				context: {
					label:
						'analyses.dialog.analysis-details.expires' | transloco,
					value: analysis()
						? (analysis()!.expiresAt | timestamp)
						: null,
				}
			"
		/>
	</div>

	<ng-container
		*ngTemplateOutlet="
			item;
			context: {
				label: 'analyses.dialog.analysis-details.owner' | transloco,
				value: owner()?.displayName,
			}
		"
	/>
</section>

<ng-template #item let-label="label" let-value="value">
	<div class="w-full flex flex-col gap-1">
		<p class="font-semibold text-sm">
			{{ label }}
		</p>

		@if (loading()) {
			<p [tuiSkeleton]="3"></p>
		} @else {
			<p>{{ value }}</p>
		}
	</div>
</ng-template>
